<template>
   <v-layout
  class="pt-3"
  >
    <v-navigation-drawer 
      app
      
      
    v-model="drawer" 
    
    >


      <v-list dense >

        <!--v-divider></v-divider-->

        <v-list-tile v-for="item in items" :key="item.title" :to="item.url" ripple>
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>

    <!--v-toolbar class="hidden-md-and-up">
      <v-toolbar-side-icon @click="showHideMenu" ></v-toolbar-side-icon>

    </v-toolbar-->

 
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      drawer: true,
      mini: false,
      items: [
        { title: "Home", icon: "dashboard", url: "/" },
        { title: "Produtos", icon: "queue_music", url: "/produtos" },
        { title: "Artistas", icon: "supervisor_account", url: "/artistas" },
        { title: 'Obras', icon: 'waves', url:'/obras' },
        { title: "Compositores", icon: "person", url: "/compositores" },
        { title: "Editoras", icon: "playlist_add_check", url: "/editoras" },
        { title: "Calendário", icon: "calendar_today", url: "/calendario" },
        { title: "Distribuir", icon: "call_split", url: "/distribuir" }
      ],
      right: null
    };
  },
  computed:{
    ...mapGetters([
      'user'
    ])
  },
  methods: {
    showHideMenu: function() {
      this.drawer = !this.drawer;
      return;
      /*if(this.mini){
            this.drawer = this.mini = false;
          }
          else{
            this.drawer = this.mini = true;
          }*/
    }
  }
};
</script>